import {ModuleLoader} from 'ca-middleware';
import {MapModule} from '@/views/emap/MapModule';
import {ModuleBanner} from '@/views/banner/ModuleBanner.ts';
import {ModuleComposite} from '@/views/composite/ModuleComposite.ts';
import {ModuleSwitchMap} from '@/views/switchMap/ModuleSwitchMap';
import {ModuleToolBar} from '@/views/toolbar/ModuleToolBar';
import {ModuleThematicMap} from '@/views/thematicMap/ModuleThematicMap';
import {ModuleSearch} from '@/views/search/ModuleSearch';
import {ModulePathPlan} from '@/views/pathPlan/ModulePathPlan';
import {ModuleGisPlot} from '@/views/plot/ModuleGisPlot';




// 引入示例模块
import {ModuleDemo} from '@/views/demoView/ModuleDemoView';

export class ModuleMain {
 public static init() {
        ModuleLoader.addModule(new MapModule());
        ModuleLoader.addModule(new ModuleBanner());
        ModuleLoader.addModule(new ModuleComposite());
        ModuleLoader.addModule(new ModuleGisPlot());
        ModuleLoader.addModule(new ModuleToolBar());
        ModuleLoader.addModule(new ModuleSwitchMap());
        ModuleLoader.addModule(new ModuleThematicMap());
        ModuleLoader.addModule(new ModulePathPlan());
        ModuleLoader.addModule(new ModuleSearch());



        // 添加示例模块至全局
        ModuleLoader.addModule(new ModuleDemo());

        ModuleLoader.start();
    }
}
